import { Breakpoint, Container as MUIContainer } from "@mui/material";
import React from "react";
import BasePaperContainer from "./BasePaperContainer";

interface BaseContainerProps {
    useTopAndBottomPadding?: boolean;
    useLeftAndRightPadding?: boolean;
    usePaperWrapper?: boolean;
    maxWidth?: Breakpoint;
    children: React.ReactNode;
}

const BaseContainer: React.FC<BaseContainerProps> = ({
    useTopAndBottomPadding = false,
    useLeftAndRightPadding = false,
    children,
    maxWidth = "xl",
    usePaperWrapper = false
}) => {
    return (
        <MUIContainer
            maxWidth={maxWidth}
            sx={{
                pt: useTopAndBottomPadding ? {
                    xs: 2,
                    sm: 2,
                    md: 4,
                    lg: 6
                } : { xs: 0 },
                pb: useTopAndBottomPadding ? {
                    xs: 2,
                    sm: 2,
                    md: 4,
                    lg: 6
                } : { xs: 0 },
                pl: useLeftAndRightPadding ? {
                    xs: 2,
                    sm: 2,
                    md: 4,
                    lg: 6
                } : { xs: 0 },
                pr: useLeftAndRightPadding ? {
                    xs: 2,
                    sm: 2,
                    md: 4,
                    lg: 6
                } : { xs: 0 },
            }}
        >
            {usePaperWrapper
                ? (
                    <BasePaperContainer>
                        {children}
                    </BasePaperContainer>
                )
                : children
            }
        </MUIContainer>
    );
};

export default BaseContainer;